import { useState, useEffect } from "react";
import { ActionFunctionArgs, Form, useActionData, useNavigate } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { myAxios } from "src/components/common/functions";
import Notification from "src/components/common/notification";
import logo from "src/img/logo.png";
import { Link } from "react-router-dom";
export default function ChangePassword(){
    const defaultNotification: {
        show: boolean, 
        title?: string, 
        msg?: string, 
        callBack?: Function, 
        preventClose?: boolean
    } = { 
        show: false, 
        title: "", 
        msg: ""
    };
    const [notification, setNotification] = useState(defaultNotification);
    const [email, setEmail] = useState(localStorage.getItem("email") || "");
    const [password, setPassword] = useState(localStorage.getItem("password") || "");
    const [newPassword, setNewPassword] = useState("");
    //--------------------------------------------------------------------------------------------
    const actionData = useActionData();
    const navigate = useNavigate();
    useEffect(() => {
        if (!actionData) return;
        if (actionData.ok === false) {
            setNotification({
                show: true,
                title: actionData.title,
                msg: actionData.msg,
            });
            return;
        }
        setNotification({
            show: true,
            title: actionData.title,
            msg: actionData.msg,
            preventClose: true,
        });

        const delayFormNotification = window.setTimeout(() => {
            if(localStorage.getItem("rememberPassword") === "true"){
                localStorage.setItem("password", actionData.newPassword);
            }else{
                localStorage.setItem("password", "");
            }
            navigate("/Login", { replace: true });
        }, 2000);

        return () => window.clearTimeout(delayFormNotification);
    }, [actionData, navigate]);
    //--------------------------------------------------------------------------------------------
    return (
        <div className = "loginBox">
            <img className = "cssLoginLogo" src = {logo} alt = ""/>
            <Form method = "post">    
            <input className = "bwinput" type = "email" placeholder = "Email" id = "email" name = "email" value = {email} onChange = {e => setEmail(e.currentTarget.value.toLowerCase())} required autoComplete = "off"/>
            <input className = "bwinput" type = "password" placeholder = "Password" id = "password" name = "password" value = {password} onChange = {e => setPassword(e.currentTarget.value)} required autoComplete = "off"/>
            <input className = "bwinput" type = "password" placeholder = "New Password" id = "newPassword"name = "newPassword" value = {newPassword} onChange = {e => setNewPassword(e.currentTarget.value)} required autoComplete = "off"/>
            <button type = "submit" className = "bwbtn">CHANGE</button>
            <Link className = "bwbtn text-decoration-none" to = "/Login">GO BACK</Link>
            </Form>
            {notification.show?
            <Notification
                title = {notification.title || ""}
                msg = {notification.msg || ""}
                closeIt = {notification.preventClose ?
                () => {} :
                (notification.callBack ?
                    notification.callBack :
                    () => setNotification({ show : false })
                )}
            />:null}
        </div>
    );
}
export async function changePasswordAction({ request } : ActionFunctionArgs) {
    const formData = await request.formData();
    const email = formData.get("email");
    const password = formData.get("password");
    const newPassword = formData.get("newPassword");
    if (!email || !password || !newPassword) {
        return {
            ok: false,
            title: "Error",
            msg: "Missing required fields",
        };
    }
    const res: any = await myAxios({ fileName: "auth/changePassword.php", formData: formData });
    if(!res) return;
    return res.data;
}